import MainCtl from './MainCtl';
import MixMapCtl from '@/page/mainPage/map/mixmap/MixMapCtl';

function createModule() {
    const MixMapModule = new MixMapCtl({
        talksE: false,
        showSearch: false,
        showZoomTool: false,
    }).init();
    const MainModule = new MainCtl(MixMapModule).init();

    MainModule.input.map.push(MixMapModule.output.default);
    MixMapModule.input.map2dContent.push(MainModule.output.LandFeature);
    return {
        MainModule,
        MixMapModule,
    };
}

export default createModule;
